import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useJumpLastUrl, useAppCookies } from '@!/Hooks'
import { usePaymentValidation } from '@!/User/Payment/Hooks/usePaymentValidation'
import { useGmoPayment, usePaymentSaveCard } from '@!/components/CreditCard/hooks'
import { CircularProgressModal, ConfirmPopupModal } from '@!/components/Modal'
import NewCardView from '@!/User/Payment/components/NewCard'

export const NewCard = () => {
  usePaymentValidation()

  const navigate = useNavigate()
  const jumpLastUrl = useJumpLastUrl()
  const location = useLocation()
  const { handleGetGmoToken } = useGmoPayment()
  const { setLastMonthlyCoursePayTypeCookie } = useAppCookies()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [saveCardMutation, getErrorMessage] = usePaymentSaveCard()

  const onSubmit = async (data, setError) => {
    const result = await handleGetGmoToken(data, setError)
    if (result.success) {
      saveCardMutation.mutate(
        { token: result.token, isUpdate: result.isUpdate },
        {
          onSuccess: () => {
            setLastMonthlyCoursePayTypeCookie('credit')
            navigate('/monthly_course/confirm')
          },
          onError: (error) => {
            const errorMessage = getErrorMessage(error)
            setIsModalOpen(true)
            setErrorMessage(errorMessage)
          },
        },
      )
    }
  }

  const pageBack = (e) => {
    e.preventDefault()

    const from = location.state?.from
    if (from === 'RestoreRoot') {
      jumpLastUrl()
      return
    }

    navigate(-1)
  }

  return (
    <>
      <NewCardView onSubmit={onSubmit} pageBack={pageBack} />
      <CircularProgressModal isOpen={saveCardMutation.isPending} />
      <ConfirmPopupModal handlePopup={() => setIsModalOpen(false)} text={errorMessage} isOpen={isModalOpen} />
    </>
  )
}

export default NewCard
